module.exports = __webpack_public_path__ + "static/media/SDFSA_3-634w.a88f18b6.webp";